import { PartnerCategory } from '@pt/enums/partner'
import { PackItem, PackItems } from './types'
import { UsageType } from '@com/enums/user'
import { STORAGE } from './config'
import { GrantOrderCostPayload } from '@pt/api/grant/index.type'
import { t } from '@/lang'
import { MessageBox } from 'element-ui'
import { withResolvers } from '@com/utils/promise'
import { GrantType } from '@pt/enums/grant'
import { UserPartnerInfo } from '@pt/api/user/type'
import { PartnerApproveStatus } from '@pt/enums/partner'

/** 判断当前用户是个人用户 */
export function isPersonalUser(category: PartnerCategory): boolean {
  return [PartnerCategory.Personal, PartnerCategory.Unapproved].includes(
    category,
  )
}

/** 判断当前用户是企业用户 */
export function isEnterpriseUser(category: PartnerCategory): boolean {
  return ![PartnerCategory.Personal, PartnerCategory.Unapproved].includes(
    category,
  )
}

/** 判断当前套餐个人是否可购买 */
export function isPersonalGrant(type: GrantType): boolean {
  return [GrantType.Personal, GrantType.PersonalAndEnterprise].includes(type)
}

/** partner是审核通过的 */
export function isApprovedPartner(partner: UserPartnerInfo): boolean {
  return partner.approve_status === PartnerApproveStatus.Approved
}

export function getPackUnit(item: PackItem): string {
  switch (item.usage_type) {
    case UsageType.DownloadPush:
      return t('playTurbo.payment.grantDialog.downloadPushUnit', {
        count: item.unit_price[1],
      }).toString()
    case UsageType.RenderVideo:
      return t('playTurbo.payment.grantDialog.renderVideoUnit', {
        count: item.unit_price[1],
      }).toString()
    case UsageType.Storage:
      return t('playTurbo.payment.grantDialog.storageUnit', {
        count: item.unit_price[1],
      }).toString()
    default:
      return ''
  }
}

export function getPackItems(): PackItems {
  return {
    download_push: {
      usage_type: UsageType.DownloadPush,
      unit_price: [0, 0],
      quantity: 0,
      amount: 0,
      enabled: true,
      count: 10,
    },
    video_credits: {
      usage_type: UsageType.RenderVideo,
      unit_price: [0, 0],
      quantity: 0,
      amount: 0,
      enabled: true,
      count: 1,
    },
    storage: {
      usage_type: UsageType.Storage,
      unit_price: [0, 0],
      quantity: 0,
      amount: 0,
      enabled: true,
      count: 6,
    },
  }
}

/** 用户已经升级到最大存储空间 */
export function isMaxStorage(totalSize: number): boolean {
  return totalSize >= STORAGE * 1024 * 1024 * 1024
}

export function transformPayload(
  packItems: PackItems,
  isMaxStorage: boolean,
): GrantOrderCostPayload {
  return {
    [UsageType.DownloadPush]: packItems[UsageType.DownloadPush].count,
    [UsageType.Storage]:
      packItems[UsageType.Storage].count > 0 && !isMaxStorage ? STORAGE : 0,
    [UsageType.RenderVideo]:
      packItems[UsageType.RenderVideo].count *
      packItems[UsageType.RenderVideo].unit_price[1],
  }
}

export function showContractMessage() {
  const { promise, resolve } = withResolvers()
  MessageBox({
    title: t(
      'playTurbo.payment.selectPackage.contract.dialog.title',
    ).toString(),
    message: t(
      'playTurbo.payment.selectPackage.contract.dialog.message',
    ).toString(),
    customClass: 'pt-custom-confirm-message pt-no-type-confirm-message',
    center: true,
    distinguishCancelAndClose: true,
    showCancelButton: true,
    confirmButtonText: t(
      'playTurbo.payment.subscription.package.contact.button',
    ).toString(),
    type: 'warning',
    callback: (action) => {
      resolve(action)
    },
  })

  return promise
}
